<template>
  <div class="OpenInAppBarAppInfoWrap">
    <slot name="appInfo"/>
    <div class="OpenInAppBarWrap">
      <div class="OpenInAppBarWrap_content">
        <h1 class="OpenInAppBarWrap_title"><i></i>{{ appdownTxt }}</h1>
        <div
          class="OpenInAppBarWrap_btnOpen"
          v-appdownload="{
            page,
            apppage: appPage,
            openurl: openUrl,
            openapp:  isOpenApp,
            refer,
            pm: pmInApp,
            version: versionInApp,
            city_id: cityId,
            extra_loupan_id: extraLoupanId,
            house_type_id: houseTypeId,
            action: actionInApp,
            sourceSoj,
            systemSoj,
            versionSoj,
            additionalParam: additionalParamInApp,
            appPath,
            isAutoOpenAppThreeTimes,
            isSendSojBusiness: isSendSojBusinessInApp,
            isSendSojComponent: isSendSojComponentInApp,
          }">
          立即打开
        </div>
        <div
          class="OpenInAppBarWrap_btnOpenInApp"
          v-appdownload="{
            page,
            openapp: 'false',
            refer,
            pm: pmDownload,
            version: versionDownload,
            action: actionDownload,
            sourceSoj,
            systemSoj,
            versionSoj,
            additionalParam: additionalParamDownload,
            isSendSojBusiness: isSendSojBusinessDownload,
            isSendSojComponent: isSendSojComponentDownload,
          }">
          下载 APP
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Appdownload from '../../plugins/app-download';

const download = new Appdownload();
export default {
  name: 'BizAppDownloadBar',
  props: {
    /**
     * example:
     * 1、v-appdownload="{version:'10.3.2',pm:'b391',action:'xxxxx'}" 默认会尝试打开APP新房列表页
     * 2、v-appdownload="{openapp:false,version:'10.3.2',pm:'b391',action:'xxxxx'}" 不尝试打开APP
     * 3、v-appdownload="{pm:34,version:'10.2.1',action:'sadasd',apppage:'loupan',cityid:11,
     *     loupanid:252896,refer:'xxxxxx'}"  尝试打开openapp组件所支持的楼盘单页
     * 4、v-appdownload="{appname:'weiliaoke',action:'xxxxx'}" 下载微聊客APP
     */
    appdownTxt: {
      type: String,
      required: false,
      default: '安居客专享特价房源',
    },
    page: {//  页面名，发码用
      type: String,
      required: false,
      default: '',
    },
    appPage: {
      /**
       * 要打开的app页面的名字（优先级高于openurl）loupan，housetype，zixun，home
        *1.loupan时需要再value里另外传递extra_loupan_id
        *2.housetype时需要再value里另外传递house_type_id和extra_loupan_id
        *3.home时无需要额外
        *4.appPage不为上面三个值，且openUrl为空，默认跳转到新房楼盘列表页（例如：appPage=loupanlist,且openUrl为空）
       */
      type: String,
      required: false,
      default: 'home',
    },
    openUrl: {//  指定打开的url，例如：'openanjuke://jump/core/common?params=encodeURIComponent('{"url":"http://m.anjuke.com/","ajk_type": "1"}')'
      type: String,
      required: false,
      default: '',
    },
    isOpenApp: {//  是否打开app，默认不传也是打开
      type: String,
      default: 'true',
    },
    refer: {//  用于统计打开app的来源
      type: String,
      required: false,
      default: '',
    },
    pmDownload: {//  安装渠道,包号，标记页面点击的具体地方
      type: String,
      required: false,
      default: '',
    },
    pmInApp: {//  安装渠道,包号，标记页面点击的具体地方
      type: String,
      required: false,
      default: '',
    },
    versionInApp: {//  (app内打开)安卓版本号，下载指定的安卓版本
      type: String,
      required: false,
      default: '',
    },
    versionDownload: {//  （下载）安卓版本号，下载指定的安卓版本
      type: String,
      required: false,
      default: '',
    },
    cityId: {//  城市id，比如上海对应的cityId="11"
      type: String,
      required: false,
      default: '',
    },
    extraLoupanId: {//  具体要打开的楼盘单页对应的楼盘id，appPage = housetype/loupan，需要传此参数
      type: String,
      required: false,
      default: '',
    },
    houseTypeId: {//  户型id，appPage = housetype时;需要再value里另外传递houseTypeId
      type: String,
      required: false,
      default: '',
    },
    actionInApp: {//  (app内打开)soj自定义action(发码的名称)
      type: String,
      required: false,
      default: '',
    },
    actionDownload: {//  （下载）soj自定义action(发码的名称)
      type: String,
      required: false,
      default: '',
    },
    sourceSoj: {//  发码的时候需要用，应用来源：weapp、anjukeapp、58app、jjrapp、jikejia、momo、qq、ganji、unknown
      type: String,
      required: false,
      default: 'unknown',
    },
    systemSoj: {//  发码的时候需要用，手机系统（android、ios、unknown）
      type: String,
      required: false,
      default: 'unknown',
    },
    versionSoj: {//  发码的时候需要用，应用版本
      type: String,
      required: false,
      default: 'unknown',
    },
    additionalParamInApp: {// （打开） cp里一些额外的参数，比如{'style':{'style':1}, b: {c:'in'}}
      type: Object,
      default: () => {},
    },
    additionalParamDownload: {//  （下载）cp里一些额外的参数，比如{'style':{'style':1}, b: {c:'in'}}
      type: Object,
      default: () => {},
    },
    appPath: { // 自动唤起app，打开对应的页面；"协议前缀openanjuke://jump"，对照协议按需填，比如新房楼盘列表页“newhouse/building_list”
      type: String,
      required: false,
      default: '',
    },
    isAutoOpenAppThreeTimes: {
      /** 是否开启一天内自动打开APP三次,默认false：不开启；
      当页面中biz-app-download-bar或者biz-open-in-app这两个组件都存在的时候，只需要设置任意一个的isAutoOpenAppThreeTimes值为true即可
      */
      type: Boolean,
      required: false,
      default: false,
    },
    isSendSojBusinessInApp: { // 立即打开 是否发送业务点击码
      type: Boolean,
      required: false,
      default: true,
    },
    isSendSojBusinessDownload: {// 下载 是否发送业务点击码
      type: Boolean,
      required: false,
      default: true,
    },
    isSendSojComponentInApp: {// 立即打开 是否发送组件点击码
      type: Boolean,
      required: false,
      default: false,
    },
    isSendSojComponentDownload: {// 下载 是否发送组件点击码
      type: Boolean,
      required: false,
      default: false,
    },
  },
  directives: {
    appdownload: {
      inserted: download.clickDownload.bind(download),
    },
  },
};
</script>
<style scoped src='./biz-app-download-bar.css'></style>
